// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import TimezoneSelectController from "./timezone_select_controller";

application.register("timezone-select", TimezoneSelectController);

import UploadButtonController from "./upload_button_controller";

application.register("upload-button", UploadButtonController);

import UserMenuController from "./user_menu_controller";

application.register("user-menu", UserMenuController);

import FieldsetToggleController from "./fieldset_toggle_controller";

application.register("fieldset-toggle", FieldsetToggleController);

import IdController from "./id_controller";

application.register("id", IdController);
